<template>
  <div id="app">
    <div class="retailmade" id="top">
      <header>
        <div class="inner">
          <a href="#top"><img src="./assets/images/logo.png" alt="logo"/></a>
          <nav>
            <button class="open">
              <svg class="navicon" height="32px" id="Layer_1" style="enable-background:new 0 0 32 32;" version="1.1" viewBox="0 0 32 32" width="32px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <path d="M4,10h24c1.104,0,2-0.896,2-2s-0.896-2-2-2H4C2.896,6,2,6.896,2,8S2.896,10,4,10z M28,14H4c-1.104,0-2,0.896-2,2  s0.896,2,2,2h24c1.104,0,2-0.896,2-2S29.104,14,28,14z M28,22H4c-1.104,0-2,0.896-2,2s0.896,2,2,2h24c1.104,0,2-0.896,2-2  S29.104,22,28,22z"/>
              </svg>
            </button>
            <button class="close">
              <svg class="navicon" height="32px" id="Layer_1" style="enable-background:new 0 0 32 32;" version="1.1" viewBox="0 -5 32 32" width="32px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <path d="M14.1,11.3c-0.2-0.2-0.2-0.5,0-0.7l7.5-7.5c0.2-0.2,0.3-0.5,0.3-0.7s-0.1-0.5-0.3-0.7l-1.4-1.4C20,0.1,19.7,0,19.5,0  c-0.3,0-0.5,0.1-0.7,0.3l-7.5,7.5c-0.2,0.2-0.5,0.2-0.7,0L3.1,0.3C2.9,0.1,2.6,0,2.4,0S1.9,0.1,1.7,0.3L0.3,1.7C0.1,1.9,0,2.2,0,2.4  s0.1,0.5,0.3,0.7l7.5,7.5c0.2,0.2,0.2,0.5,0,0.7l-7.5,7.5C0.1,19,0,19.3,0,19.5s0.1,0.5,0.3,0.7l1.4,1.4c0.2,0.2,0.5,0.3,0.7,0.3  s0.5-0.1,0.7-0.3l7.5-7.5c0.2-0.2,0.5-0.2,0.7,0l7.5,7.5c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3l1.4-1.4c0.2-0.2,0.3-0.5,0.3-0.7  s-0.1-0.5-0.3-0.7L14.1,11.3z"/>
              </svg>
            </button>
            <ul>
              <li><a href="#chapter_why">Retailmade</a></li>
              <li><a href="#chapter_employability">Inzetbaarheid</a></li>
              <li><a href="#chapter_functions">Functies</a></li>
              <li><a href="#chapter_experience_foodretail">Ervaring</a></li>
              <li><a href="#chapter_founder">TPP</a></li>
              <li><a href="#chapter_contact_dick">Mens</a></li>
              <li><a href="#form">Contact</a></li>
            </ul>
          </nav>
        </div>
      </header>
      <main class="retailmade">
        <teaser pagename="retailmade"></teaser>
        <chapters pagename="retailmade"></chapters>
      </main>
    </div>
    <footer>
      <div class="outer">
        <div class="inner">
          <div class="left">
            <a href="mailto:dick@retailmade.com">
              <svg width="55px" height="55px" viewBox="0 0 59 59" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <!-- Generator: Sketch 64 (93537) - https://sketch.com -->
                  <title>mail-square@1x</title>
                  <desc>Created with Sketch.</desc>
                  <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <g id="Retailmade-desktop-V2.1" transform="translate(-143.000000, -4493.000000)">
                          <g id="Group-13" transform="translate(0.000000, 4472.947672)">
                              <g id="mail-square" transform="translate(144.021688, 21.000000)">
                                  <rect id="Rectangle-Copy-4" stroke="#FFFFFF" stroke-width="3" x="0.478311676" y="0.878613249" width="55.1430751" height="55.1430751" rx="4"></rect>
                                  <g id="mail" transform="translate(13.549849, 19.300001)" fill="white">
                                      <polygon id="Path" points="18.6433594 9.81210938 28.125 15.80625 28.125 3.56484375"></polygon>
                                      <polygon id="Path" points="0 3.56484375 0 15.80625 9.48164063 9.81210938"></polygon>
                                      <path d="M26.3671875,0 L1.7578125,0 C0.880664063,0 0.184570313,0.65390625 0.052734375,1.49589844 L14.0625,10.7261719 L28.0722656,1.49589844 C27.9404297,0.65390625 27.2443359,0 26.3671875,0 Z" id="Path"></path>
                                      <path d="M17.0332031,10.8738281 L14.5458984,12.5121094 C14.3982422,12.6087891 14.23125,12.65625 14.0625,12.65625 C13.89375,12.65625 13.7267578,12.6087891 13.5791016,12.5121094 L11.0917969,10.8720703 L0.05625,17.8523437 C0.191601563,18.6873047 0.884179687,19.3359375 1.7578125,19.3359375 L26.3671875,19.3359375 C27.2408203,19.3359375 27.9333984,18.6873047 28.06875,17.8523437 L17.0332031,10.8738281 Z" id="Path"></path>
                                  </g>
                              </g>
                          </g>
                      </g>
                  </g>
              </svg>            </a>
            <a href="https://www.linkedin.com/in/dicktenvoorde/" target="_blank">
              <svg width="55px" height="55px" viewBox="0 0 59 59" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <!-- Generator: Sketch 64 (93537) - https://sketch.com -->
                  <title>linked-in-square@1x</title>
                  <desc>Created with Sketch.</desc>
                  <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <g id="Retailmade-desktop-V2.1" transform="translate(-72.000000, -4493.000000)">
                          <g id="Group-13" transform="translate(0.000000, 4472.947672)">
                              <g id="linked-in-square" transform="translate(73.000000, 21.000000)">
                                  <rect id="Rectangle" stroke="#FFFFFF" stroke-width="3" x="0.58399499" y="0.878613249" width="55.1430751" height="55.1430751" rx="4"></rect>
                                  <g id="linkedin" transform="translate(16.655533, 17.050001)" fill="#FFFFFF" fill-rule="nonzero">
                                      <path d="M5.0742,22.5603 L0.4398,22.5603 L0.4398,7.6509 L5.0739,7.6509 L5.0742,22.5603 L5.0742,22.5603 Z M2.7579,5.613 C1.2726,5.613 0.0702,4.4091 0.0702,2.9256 C0.0705,1.4442 1.2732,0.24 2.7579,0.24 C4.2396,0.24 5.4432,1.4436 5.4432,2.9256 C5.4432,4.4091 4.2396,5.613 2.7579,5.613 Z M22.4298,22.56 L17.7996,22.56 L17.7996,15.3099 C17.7996,13.5807 17.7681,11.3565 15.3909,11.3565 C12.981,11.3565 12.6105,13.2399 12.6105,15.1842 L12.6105,22.56 L7.9797,22.56 L7.9797,7.6509 L12.4245,7.6509 L12.4245,9.6879 L12.4866,9.6879 C13.1055,8.5158 14.6175,7.2798 16.8708,7.2798 C21.5631,7.2798 22.4295,10.368 22.4295,14.3817 L22.4295,22.56 L22.4298,22.56 Z" id="Shape"></path>
                                  </g>
                              </g>
                          </g>
                      </g>
                  </g>
              </svg>
            </a>
            <p> <a href="http://totalpreparedprogram.com" target="_blank">Total Prepared Program</a> is een product van <a href="http://www.retailmade.com" target="_blank">Retailmade</a></p>
            <p class="dot">·</p>
            <p>Website gemaakt door <a href="https://www.solide.agency" target="_blank">Sólide Agency</a></p>
          </div>
          <div class="right">
            <img src="./assets/images/phone@1x.svg" alt="contact button linkedin"/>
            <a href="tel:+31634532829">+31 6 34 53 28 29</a>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<style lang="scss">
#app {
}
</style>

<script>
// @ is an alias to /src
import teaser from '@/components/teaser.vue'
import chapters from '@/components/chapters.vue'

// import * as hamburgermenu from '@/assets/js/hamburgermenu.js'

export default {
  name: 'About',
  components: {
    teaser,
    chapters
  },
  mounted(){
    if('querySelector' in document && 'querySelectorAll' in document && 'addEventListener' in window) {
      var headerBar = document.querySelector('nav');
      var open = document.querySelector('.open');
      var close = document.querySelector('.close');
      var menu = document.querySelector('nav ul');
      var items = document.querySelectorAll('ul li');

      menu.classList.add('first');

      open.addEventListener('click', function(){
        menu.classList.add('open-menu');
        menu.classList.remove('close-menu');

        headerBar.classList.add('open-menu-bar');
        headerBar.classList.remove('close-menu-bar');

        open.style.display = "none";
        close.style.display = "block";
      })

      close.addEventListener('click', function(){
        menu.classList.remove('open-menu');
        menu.classList.add('close-menu');

        headerBar.classList.remove('open-menu-bar');
        headerBar.classList.add('close-menu-bar');

        close.style.display = "none";
        open.style.display = "block";
      })

      function deleteClass(){
        for (var i = 0; i < items.length; i++) {
          items[i].classList.remove('current');
        }
      }

      items.forEach(function(element){

        element.addEventListener('click', function(){

          deleteClass();
          this.classList.add('current');

          menu.classList.remove('open-menu');

          headerBar.classList.remove('open-menu-bar');

          close.style.display = "none";
          open.style.display = "block";
        })
      })

      /* on scroll change menu layout */
      window.addEventListener("scroll", function() {
        var chapters = document.querySelectorAll(".chapters > div:not(.chapter_experience_two_worlds)");

        for (var i = 0; i < chapters.length; i++) {
          if (window.scrollY > (chapters[i].offsetTop - 150)){
            deleteClass();
            items[i].classList.add('current');
          }
          if(window.scrollY < 200){
            deleteClass();
          }
        }
      })
    }
  }
}

</script>
